// LineTagPill — the compact paragraph line tag from the lines mockup (#1830):
// a small pill with the line's short code on the line color's light tint.
// Shared between AnnotatedText (view mode) and EditableSynopsis (edit-mode badges).

import { memo } from 'react';
import { hexAlpha } from '@/utils/lineColorUtils';
import { getLineShortCode } from '@/utils/lineHelpers';

interface LineTagPillProps {
    line: { code: string; title?: string };
    color: string;
    fontSize?: string;
    onClick?: (e: React.SyntheticEvent<HTMLElement>) => void;
}

export const LineTagPill = memo(({ line, color, fontSize = '10px', onClick }: LineTagPillProps) => (
    <span
        data-line-marker
        title={line.title?.trim() || line.code}
        onClick={onClick}
        onKeyDown={
            onClick
                ? e => {
                      if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          onClick(e);
                      }
                  }
                : undefined
        }
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
        className="mr-1 inline-block select-none rounded font-semibold leading-[1.4]"
        style={{
            fontSize,
            color,
            backgroundColor: hexAlpha(color, 0.15),
            padding: '1px 4px',
            ...(onClick && { cursor: 'pointer' }),
        }}
    >
        {getLineShortCode(line)}
    </span>
));

LineTagPill.displayName = 'LineTagPill';
